import React, { createElement, Suspense } from 'react';
import { render } from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { RecoilRoot, useRecoilValue } from 'recoil';
import routes from './routes';
import MainNav from './shared/MainNav';

const queryClient = new QueryClient();

const RegistrationApp = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <Router hashType="slash">
          <header className="Main__header">
            <div className="Container">
              <h1>Register</h1>
            </div>
            <MainNav routes={routes}></MainNav>
          </header>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              {routes.map((route, index) => (
                <Route key={index} {...route} element={<route.main></route.main>}></Route>
              ))}
            </Routes>
          </Suspense>
        </Router>
      </RecoilRoot>
    </QueryClientProvider>
  );
};

if (!customElements.get('registration-app')) {
  customElements.define(
    'registration-app',
    class extends HTMLElement {
      connectedCallback() {
        const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
        render(createElement(RegistrationApp, Object.fromEntries(props)), this);
      }
    }
  );
}
